"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformClient = void 0;
const Client_1 = require("./api/resources/auth/client/Client");
const Client_2 = require("./api/resources/books/client/Client");
const Client_3 = require("./api/resources/catalog/client/Client");
const Client_4 = require("./api/resources/entitlement/client/Client");
const Client_5 = require("./api/resources/integration/client/Client");
const Client_6 = require("./api/resources/llm/client/Client");
const Client_7 = require("./api/resources/payment/client/Client");
const Client_8 = require("./api/resources/teams/client/Client");
const Client_9 = require("./api/resources/userProfile/client/Client");
const Client_10 = require("./api/resources/vms/client/Client");
class PlatformClient {
    constructor(_options) {
        this._options = _options;
    }
    get auth() {
        var _a;
        return ((_a = this._auth) !== null && _a !== void 0 ? _a : (this._auth = new Client_1.Auth(this._options)));
    }
    get books() {
        var _a;
        return ((_a = this._books) !== null && _a !== void 0 ? _a : (this._books = new Client_2.Books(this._options)));
    }
    get catalog() {
        var _a;
        return ((_a = this._catalog) !== null && _a !== void 0 ? _a : (this._catalog = new Client_3.Catalog(this._options)));
    }
    get entitlement() {
        var _a;
        return ((_a = this._entitlement) !== null && _a !== void 0 ? _a : (this._entitlement = new Client_4.Entitlement(this._options)));
    }
    get integration() {
        var _a;
        return ((_a = this._integration) !== null && _a !== void 0 ? _a : (this._integration = new Client_5.Integration(this._options)));
    }
    get llm() {
        var _a;
        return ((_a = this._llm) !== null && _a !== void 0 ? _a : (this._llm = new Client_6.Llm(this._options)));
    }
    get payment() {
        var _a;
        return ((_a = this._payment) !== null && _a !== void 0 ? _a : (this._payment = new Client_7.Payment(this._options)));
    }
    get teams() {
        var _a;
        return ((_a = this._teams) !== null && _a !== void 0 ? _a : (this._teams = new Client_8.Teams(this._options)));
    }
    get userProfile() {
        var _a;
        return ((_a = this._userProfile) !== null && _a !== void 0 ? _a : (this._userProfile = new Client_9.UserProfile(this._options)));
    }
    get vms() {
        var _a;
        return ((_a = this._vms) !== null && _a !== void 0 ? _a : (this._vms = new Client_10.Vms(this._options)));
    }
}
exports.PlatformClient = PlatformClient;
